/**
 * Leave animation of `app-message`.
 *
 * The library message plays its leave animation through `animate.leave` on the `p-message` host. That binding lives
 * in the `app-message` component view, and Angular runs only the leave animations of the view being removed, not
 * those of the component views nested in it, so a consumer `@if` that removes `app-message` skips it.
 * `app-message` therefore declares `animate.leave` with `app-message-leave` on its own host; Angular keeps the host
 * in the DOM until the host animation ends. Meanwhile the message box inside replays the library leave keyframes
 * with the library timing (fade, row collapse), and the host collapses the margin a consumer class puts on it,
 * which the library keyframes collapsed while that class sat on `p-message` itself.
 */
export const styles = () => `.app-message-leave {
  animation: app-message-leave 0.15s ease-in forwards;
}

.app-message-leave > .p-message {
  animation: p-animate-message-leave 0.15s ease-in forwards;
  overflow: hidden;
}

@keyframes app-message-leave {
  to {
    margin: 0;
  }
}`;
